// OfficialDetails.jsx
import {Typography} from "@mui/material";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import properties from "constants/ApplicationConstants";
import {formatDate} from "constants/ApplicationConstants";
import {formatDesignation} from "constants/ApplicationConstants";
import dayjs from "dayjs";
import Bill from "layouts/billing/components/_Bill";

function OfficialDetails({details = {}}) {
  return (
    <MDBox pb={0} px={2}>
      <MDBox pt={3} px={2}>
        <Typography variant="h6" fontWeight="bold" fontFamily={properties.fontFamily}>
          Official Details
        </Typography>
      </MDBox>
      <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
        <Bill
          empId={details?.empId}
          username={details?.userName}
          empType={details.empType}
          joiningDate={formatDate(details.joinDate)}
          designation={formatDesignation(details.designation)}
          email={details.officialEmailAddress}
          skypeId={details.skypeId}
          noticePeriod={
            details.noticePeriod === null || details.noticePeriod === undefined
              ? "0 Months"
              : details.noticePeriod === 1
              ? "1 Month"
              : `${details.noticePeriod} Months`
          }
          extension={details.extension}
          bayArea={details.bayArea}
          reportingName={details.reportingName}
          probationStartDate={formatDate(details.probationStarDate)}
          probationEndDate={formatDate(details.probationEndDate)}
          CTC={details.ctc}
        />
      </MDBox>
    </MDBox>
  );
}

export default OfficialDetails;
